import React from "react";
import NavBar from "./NavBar/NavBar";
import Banner from "./Banner/Banner";
import { Box } from "@mui/material";
import "./Home.css"
import SVGMainBackground from "./SVGMainBackground";


const Home = () =>{
    return(<Box id="Home">
      <NavBar/>
      <Banner/>
      <SVGMainBackground />
    </Box>);
}

export default Home;